<template>
     <div v-if="!hide" class="form-network form-network-instagram" >
        <details open>
            <summary>{{ $t('dash.post-creator.form.instagram.visibility') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="type-switch" v-if="canStorify">
                    {{ $t('dash.post-creator.form.instagram.share-as-story') }}
                    <ComponentSwitch :value="formData.formDataNetwork.instagram.storification ? formData.formDataNetwork.instagram.storification.active : false" :onChange="handlerSharePostInStory" :id="'switch-settings-advanced-instagram-1'"></ComponentSwitch>
                </div>
                <div class="type-switch" v-if="canStorify" :style="{opacity: formData.formDataNetwork.instagram.storification && formData.formDataNetwork.instagram.storification.active ? 1 : 0.6}">
                    {{ $t('dash.post-creator.form.instagram.share-story-facebook') }}
                    <ComponentSwitch :value="formData.formDataNetwork.instagram.storification && formData.formDataNetwork.instagram.storification.active && formData.formDataNetwork.instagram.storification.shareInFacebook" :onChange="handlerSharePostInStoryFacebook" :isDisable="!(formData.formDataNetwork.instagram.storification && formData.formDataNetwork.instagram.storification.active)" :id="'switch-settings-advanced-instagram-2'"></ComponentSwitch>
                </div>
                
                <div class="list-simple-btn">
                    <Tooltip
                        :active="false"
                        position="bottom"
                        classCustom="type-btn-simple"
                        @click="openAddIdentifierMode"
                    >
                        <i class="fa-regular fa-circle-user"></i>
                        <p>{{$tc('dash.post-creator.form.instagram.tagged-person', formDataInstagram.personsIdentified.length) }} <span class="pink">({{ formDataInstagram.personsIdentified.length || '0' }})</span></p>
                    </Tooltip>


                    <Tooltip
                        :active="false"
                        position="bottom"
                        classCustom="type-btn-simple"
                        @click="openAddCollaboratorMode"
                    >
                        <i class="fa-regular fa-circle-user"></i>
                        <p>{{ $t('dash.post-creator.form.instagram.collaborator') }} <span class="pink">({{ formDataInstagram.collaborators.length || '0' }})</span></p>

                    </Tooltip>


                    <Tooltip 
                        :text="nativeModeWarning"
                        :active="!nativeMode"
                        position="bottom"
                        :classCustom="`type-btn-simple ${!nativeMode ? 'locked' : ''}`"
                        @click="nativeMode && addMode('addPlaceMode')"
                    >
                        <i class="fa-solid fa-map-pin"></i>
                        <p>{{ $t('dash.post-creator.form.instagram.place') }} <span class="pink">({{ formData.formDataNetwork.instagram.place ? '1' : '0' }})</span></p>
                
                    </Tooltip>
                    <Tooltip 
                        :text="nativeModeWarning"
                        :active="!nativeMode"
                        position="bottom"
                        :classCustom="`type-btn-simple ${!nativeMode ? 'locked' : ''}`"
                        @click="nativeMode && addMode('addMusicMode')"
                    >
                        <i class="fa-solid fa-music"></i>
                        <p>{{ $t('dash.post-creator.form.instagram.music') }} <span class="pink">({{ formData.formDataNetwork.instagram.music ? '1' : '0' }})</span></p>
                    </Tooltip>

                    <Tooltip 
                        :text="nativeModeWarning"
                        :active="!nativeMode"
                        position="bottom"
                        :classCustom="`type-btn-simple ${!nativeMode ? 'locked' : ''}`"
                        @click="nativeMode && addMode('addProductMode')"
                    >
                        <i class="fa-regular fa-bag-shopping"></i>
                        <p>{{ $t('dash.post-creator.form.instagram.product') }} <span class="pink">({{ formData.formDataNetwork && formData.formDataNetwork.instagram.products ? formData.formDataNetwork.instagram.products.length : '0' }})</span></p>
                    </Tooltip>
                </div> 
              
            </div>      
        </details>
        <details open v-if="filesValid.length !== 1 || filesValid[0].type2 !== 'video'">
            <summary>{{ $t('dash.post-creator.form.instagram.format') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="list-radio-btn" :class="{disable: ratioIsDisable}">
                    <div class="type-btn-simple" @click="changeRatio('auto')">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : !ratioIsDisable && formDataInstagram.ratio && formDataInstagram.ratio =='auto'}"></i>
                        <p>Original</p>
                    </div>

                    <div class="type-btn-simple" @click="changeRatio('4:5')">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : !ratioIsDisable && formDataInstagram.ratio && formDataInstagram.ratio =='4:5'}"></i>
                        <p>Ratio 4:5</p>
                    </div>
                    
                    <div class="type-btn-simple" @click="changeRatio('1:1')">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : ratioIsDisable || !formDataInstagram.ratio || formDataInstagram.ratio =='1:1'}"></i>
                        <p>Ratio 1:1</p>
                    </div>

                    <div class="type-btn-simple" @click="changeRatio('16:9')">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : !ratioIsDisable && formDataInstagram.ratio && formDataInstagram.ratio =='16:9'}"></i>
                        <p>Ratio 16:9</p>
                    </div>
                 
                  
                   
                </div>  
            </div>      
        </details>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from '@/store/index.js';
    import ComponentSwitch from '@/components/dash/utils/switch.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '@/components/mixins/Bots.vue'
    import minxinPost from '@/components/mixins/Posts.vue'
    import { getFilesByNetwork, isNativeInstagram, allInstagramNative } from './../../../utils'
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
    import minxinNotification from '@/components/mixins/Notif.vue'
    export default {

        components: {
            ComponentSwitch,
            SnippetNetwork,
            Tooltip
        },
        mixins: [minxinBot,minxinPost, minxinNotification],

        props: {
            hide : {
                type: Boolean,
                default: false
            },
            formData: {
                type: Object,
                default: () => ({})
            },
            files:Object,
            idPageRenderNetworkSelected: {
                type: String,
                default: null
            },
        },

        data() {
            return {
                inputModel:{
                    switchCustomSnippet: false,
                    urlImageSnippet: "",
                    titleSnippet: "",
                    descriptionSnippet: "",
                },

                formDataInstagram : {
                    personsIdentified : [],
                    collaborators : [],
                    place : undefined,
                    music : undefined,
                    ratio : undefined
                },

                lastModeSelected : undefined
            }
        },

        
        mounted() {
            EventBus.$on('eventSearchFromSelectPerson', this.searchPerson);
            EventBus.$on('eventClickSelectPerson', this.addPerson);
            EventBus.$on('eventRemoveSelectPerson', this.removePerson);

            EventBus.$on('eventSearchFromSelectPlace', this.searchPlace);
            EventBus.$on('eventClickSelectPlace', this.addPlace);
            EventBus.$on('eventRemoveSelectPlace', this.removePlace);

            EventBus.$on('eventSearchFromSelectMusic', this.searchMusic);
            EventBus.$on('eventClickSelectMusic', this.addMusic);
            EventBus.$on('eventRemoveSelectMusic', this.removeMusic);

            EventBus.$on('eventGetTrendShopsFromSelectProduct', this.getTrendShops);
            EventBus.$on('eventSearchShopsFromSelectProduct', this.searchShops);
            EventBus.$on('eventSearchProductFromSelectProduct', this.searchProduct);
            EventBus.$on('eventGetTrendProductsFromSelectProduct', this.getTrendProducts);   
            EventBus.$on('eventGetVariantsProductFromSelectProduct', this.getVariantsProduct);
            EventBus.$on('eventClickSelectProduct', this.addProduct);
            EventBus.$on('eventRemoveSelectProduct', this.removeProduct);

            if (this.formData.formDataNetwork.instagram) this.formDataInstagram = this.formData.formDataNetwork.instagram

        },

        methods: {
           
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },
            async searchPerson(value,idEvent) {
                let page = this.pagesSelected.find(isNativeInstagram)
                let result = []
                if (page) {
                    result = (await this.getMentionsByApi(page.id, value, false, true)).mentions
                }
                EventBus.$emit("resultSearchFromSelectPerson", result,idEvent)
            },
            addPerson(person) {
                console.log("addPerson")
                switch (this.lastModeSelected) {
                    case 'addIdentifierMode':
                        this.formDataInstagram.personsIdentified = [
                            ...this.formDataInstagram.personsIdentified.filter(p => p.id !== person.id || p.idFile !== person.idFile),
                            person
                        ]
                        break;
                    case 'addCollaboratorMode':
                        this.formDataInstagram.collaborators = [...this.formDataInstagram.collaborators.filter(p => p.id !== person.id),person]
                        break;
                }
           
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },
            removePerson(idPerson, idFile = null) {
                switch (this.lastModeSelected) {
                    case 'addIdentifierMode':
                        this.formDataInstagram.personsIdentified = this.formDataInstagram.personsIdentified.filter(p => p.id !== idPerson || (idFile && p.idFile !== idFile))
                        break;
                    case 'addCollaboratorMode':
                        this.formDataInstagram.collaborators = this.formDataInstagram.collaborators.filter(p => p.id !== idPerson)
                        break;
                }
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },

            openAddIdentifierMode() {
                this.addMode('addIdentifierMode')
            },

            openAddCollaboratorMode() {
                this.addMode('addCollaboratorMode')
            },

            async searchPlace(network, value,idEvent) {
                if (network !== 'instagram') return
                let page = this.pagesSelected.find(isNativeInstagram)
                
                let result = []
                if (page) {
                    result = (await this.getLocation(page.id, value)).body.locations
                }
                EventBus.$emit("resultSearchFromSelectPlace", result, idEvent)
            },
            addPlace(network, place) {
                if (network !== 'instagram') return
                this.formDataInstagram.place = place
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },
            removePlace(network) {
                if (network !== 'instagram') return
                this.formDataInstagram.place = undefined
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },

            async searchMusic(value,idEvent) {
                let page = this.pagesSelected.find(isNativeInstagram)
                let result = []
                if (page) {
                    result = (await this.getMusicInstagram(page.id, value, "music_in_feed")).body.musics
                }
                EventBus.$emit("resultSearchFromSelectMusic", result, idEvent)
            },
            addMusic(music) {
                this.$set(this.formDataInstagram, 'music', music)
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },
            removeMusic() {
                this.$set(this.formDataInstagram, 'music', undefined)
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },


            async getTrendShops(idEvent) {
                let page = this.pagesSelected.find(isNativeInstagram)
                let result = []
                if (page) {
                    result = (await this.getTrendShopsInstagram(page.id)).body.shops
                }
                EventBus.$emit("resulttGetTrendShopFromSelectProduct", result, idEvent)
            },

            async searchShops(value,idEvent) {
                
                let page = this.pagesSelected.find(isNativeInstagram)
                let result = []
                console.log("searchShops",page)
                if (page) {
                    result = (await this.searchShopsInstagram(page.id, value)).body.shops
                }
                EventBus.$emit("resultSearchShopFromSelectProduct", result, idEvent)
            },

            async searchProduct(shopId, value ,idEvent) {
                let page = this.pagesSelected.find(isNativeInstagram)
                let result = []
                if (page) {
                    result = (await this.searchItemsShopInstagram(page.id, shopId , value)).body.items
                }
                EventBus.$emit("resultSearchProductFromSelectProduct", result, idEvent)
            },

            async getTrendProducts(shopId, idEvent) {
                let page = this.pagesSelected.find(isNativeInstagram)
                let result = []
                if (page) {
                    result = (await this.getTrendItemsShopInstagram(page.id, shopId)).body.items	
                }
                EventBus.$emit("resultGetTrendProductsFromSelectProduct", result, idEvent)
            },
            
            async getVariantsProduct(productId, shopId, idEvent) {
                let page = this.pagesSelected.find(isNativeInstagram)
                let result = []
                if (page) {
                    result = (await this.chooseItemShopInstagram(page.id, productId, shopId)).body.items	
                }
                EventBus.$emit("resultGetVariantsProductFromSelectProduct", result, idEvent)
            },

            addProduct(product) {
                this.formDataInstagram.products = [...this.formDataInstagram.products.filter(p => p.id !== product.id), product]
           
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },
            removeProduct(idProduct) {
                this.formDataInstagram.products = this.formDataInstagram.products.filter(p => p.id !== idProduct)
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },

            changeRatio(ratio) {
                console.log("changeRatio",ratio)
                this.formDataInstagram.ratio = ratio
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },
            handlerSharePostInStory(state) {
                if(!this.formDataInstagram.storification) this.formDataInstagram.storification = {}
                this.formDataInstagram.storification.active = state
                if(!state) this.formDataInstagram.storification.shareInFacebook = false
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },
            handlerSharePostInStoryFacebook(state) {
                if(!this.formDataInstagram.storification) this.formDataInstagram.storification = {}
                this.formDataInstagram.storification.shareInFacebook = state
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },

            fileAdded(ids) {
                if (!ids) return

                if (this.filesValid.length >= 1 && ids.some(id => this.files[id].info.type2 == 'video' && this.files[id].info.duration > 60)) {
                    this.notify({
                        title: this.$t('dash.post-creator.notify.instagram-carousel-video-title'),
                        text: this.$t('dash.post-creator.notify.instagram-carousel-video-text'),
                        color: 'primary',
                        time: 0,
                        id: Date.now()
                    })
                }
            }
        },
        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
            ratioIsDisable() {
                const files = this.formData.files.filter(file => ['video', 'image'].includes(file.type2))
                return files.length > 1 || (files.length == 1 && files[0].type2 == 'video')
            },
            canStorify() {
                return allInstagramNative(this.pagesSelected)
            },

            filesValid() {
                return getFilesByNetwork(this.formData.files, ['instagram'], {["instagram"]: this.formData.formDataNetwork['instagram']}, this.files, true)['instagram']
            },

            nativeMode() {
                if (this.idPageRenderNetworkSelected) {
                    return isNativeInstagram(this.allPages[this.idPageRenderNetworkSelected])
                }else{
                    return allInstagramNative(this.pagesSelected)
                }
            },

            // Les pages qui bloquent le mode natif : meme perimetre que nativeMode ci-dessus
            // (une seule page quand le rendu par page est actif, sinon toute la selection).
            nonNativeInstagramPages() {
                if (this.idPageRenderNetworkSelected) {
                    const page = this.allPages[this.idPageRenderNetworkSelected]
                    return page && page.network === 'instagram' && !isNativeInstagram(page) ? [page] : []
                }

                return this.pagesSelected.filter(page => (
                    page && page.network === 'instagram' && !isNativeInstagram(page)
                ))
            },

            // Le tooltip accepte du HTML (meme technique que mentionsWarningTextContent dans Form.vue).
            // On nomme les pages a reconnecter : sans ca le client voit "mode natif requis" sans savoir
            // laquelle de ses pages instagram est deconnectee.
            nativeModeWarning() {
                const label = this.$t('dash.post-creator.form.instagram.native-mode-only')

                if (!this.nonNativeInstagramPages.length) return label

                return [
                    label,
                    `<b>${this.$t('dash.post-creator.form.instagram.native-mode-reconnect')}</b>`,
                    ...this.nonNativeInstagramPages.map(page => `• ${page.name}`)
                ].join('<br>')
            }
        },

        watch: {
            ['formData.formDataNetwork.instagram']() {
                if (this.formData.formDataNetwork.instagram) this.formDataInstagram = this.formData.formDataNetwork.instagram
            }
        },

        beforeDestroy () {
            EventBus.$off('eventSearchFromSelectPerson', this.searchPerson);
            EventBus.$off('eventClickSelectPerson', this.addPerson);
            EventBus.$off('eventRemoveSelectPerson', this.removePerson);

            EventBus.$off('eventSearchFromSelectPlace', this.searchPlace);
            EventBus.$off('eventClickSelectPlace', this.addPlace);
            EventBus.$off('eventRemoveSelectPlace', this.removePlace);

            EventBus.$off('eventSearchFromSelectMusic', this.searchMusic);
            EventBus.$off('eventClickSelectMusic', this.addMusic);
            EventBus.$off('eventRemoveSelectMusic', this.removeMusic);


            
            EventBus.$off('eventGetTrendShopsFromSelectProduct', this.getTrendShops);
            EventBus.$off('eventSearchShopsFromSelectProduct', this.searchShops);
            EventBus.$off('eventSearchProductFromSelectProduct', this.searchProduct);
            EventBus.$off('eventGetTrendProductsFromSelectProduct', this.getTrendProducts);
            EventBus.$off('eventGetVariantsProductFromSelectProduct', this.getVariantsProduct);
            EventBus.$off('eventClickSelectProduct', this.addProduct);
            EventBus.$off('eventRemoveSelectProduct', this.removeProduct);
        }
        
    }
</script>